import "core-js/modules/es.array.push.js";
import i18n from '@/lang';
import { ref } from 'vue';
import { post_Json_elk_statistic } from '@/jsUtils/nodejsRequest';
export default {
  setup() {
    const menuRef = ref(null);
    const itemRef = ref(null);
    const value = ref(0);
    const switch1 = ref(false);
    const switch2 = ref(false);

    // 如下使用i18n的方法来获得不同语言环境下的文字
    const options = [{
      text: i18n.global.t('messages.menu_home'),
      value: 0
    }, {
      text: i18n.global.t('messages.menu_products'),
      value: 1
    }, {
      text: i18n.global.t('messages.menu_about_us'),
      value: 2
    }];
    const onConfirm = () => {
      itemRef.value.toggle();
      // 或者
      // menuRef.value.close();
    };

    const logoimg = require('@/assets/amalia.png');
    return {
      menuRef,
      itemRef,
      value,
      switch1,
      switch2,
      options,
      onConfirm,
      logoimg
    };
  },
  data() {
    return {
      selectindex: 0
    };
  },
  props: {
    // 当前索引
    index: {
      type: Number,
      default: 0
    }
  },
  watch: {
    value(newVal, oldVal) {
      // console.log("watch value: old is " + oldVal + ", new is " + newVal);
    }
  },
  mounted() {
    if (0 == this.index) {
      this.value = 0;
      this.selectindex = 0;
    } else if (1 == this.index) {
      this.value = 1;
      this.selectindex = 1;
    } else if (2 == this.index) {
      this.value = 2;
      this.selectindex = 2;
    }
    // 挂载父组件的事件
    // this.$parent.$on("RouteEvent", this.onParentEvent);

    this.$nextTick(() => {
      this.UpdateHeight();
    });
  },
  methods: {
    // 更新头部高度
    UpdateHeight() {
      // 获得show section的组件的属性
      let show_section = document.getElementById("imgtrans_head_container");
      let head_section = document.getElementById("imgtrans_head");
      let head_container_height = 200;
      head_container_height = show_section.clientHeight;
      head_section.style.height = head_container_height + "px";

      // 尺寸适配
      window.onresize = () => {
        head_section.style.height = head_container_height + "px";
      };
    },
    //点击使用指南

    handelclick(value) {
      // console.log("click ", value, " select index ", this.selectindex);
      if (0 == value) {
        this.$router.push({
          path: '/'
        });
        // this.selectindex = 0;
      } else if (1 == value) {
        this.$router.push({
          path: '/product'
        });
        // this.selectindex = 1;
      } else if (2 == value) {
        this.$router.push({
          path: '/about_us'
        });
        // this.selectindex = 2;

        let data = {
          "event": "page_home_click",
          "data": {
            "home_click_name": "goto_about_us",
            "home_click_data": "about_us_page",
            "home_click_product_type": "about_us"
          }
        };
        post_Json_elk_statistic(data);
      }
      this.value = this.selectindex;
    },
    handlechange(value) {
      // console.log("change ", value);
    },
    onParentEvent(curindex) {
      // console.log("onParentEvent: " + curindex);
      // this.selectindex = index;
    }

    // 获得语言环境，根据语言环境设置不同的文字
  }
};